module.exports = __webpack_public_path__ + "static/logo-bce5d871a7d0570650165bf3eef823e4.png";